class VariantPicker extends HTMLElement {
  connectedCallback() {
    const jsonEl = this.querySelector('[data-variant-json]');
    this.variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

    this.selects = Array.from(this.querySelectorAll('[data-option-index]'));
    this.idInput = this.querySelector('[data-variant-id-input]');
    this.priceEl = this.querySelector('[data-variant-price]');
    this.submitButton = this.querySelector('[data-variant-submit]');
    this.submitLabel = this.querySelector('[data-variant-submit-label]');

    this.selects.forEach((select) => {
      select.addEventListener('change', () => this.#onOptionChange());
    });
  }

  #onOptionChange() {
    const selectedOptions = this.selects.map((select) => select.value);

    const matchedVariant = this.variants.find((variant) =>
      selectedOptions.every((value, index) => variant.options[index] === value)
    );

    if (!matchedVariant) {
      // No exact combination exists (e.g. sold-out permutation with no
      // variant record) — disable purchase rather than submit garbage.
      if (this.submitButton) this.submitButton.disabled = true;
      return;
    }

    if (this.idInput) this.idInput.value = matchedVariant.id;

    if (this.priceEl) {
      const hasCompareAt =
        matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price;

      this.priceEl.innerHTML = `
        ${hasCompareAt ? `<span class="product-page__price--compare">${this.#formatMoney(matchedVariant.compare_at_price)}</span>` : ''}
        <span class="product-page__price--current">${this.#formatMoney(matchedVariant.price)}</span>
      `;
    }

    if (this.submitButton) {
      this.submitButton.disabled = !matchedVariant.available;
    }
    if (this.submitLabel) {
      this.submitLabel.textContent = matchedVariant.available
        ? this.submitLabel.dataset.addToCartText || this.submitLabel.textContent
        : this.submitLabel.dataset.soldOutText || this.submitLabel.textContent;
    }
  }

  #formatMoney(cents) {
    // Falls back to a plain decimal if Shopify's currency formatting
    // isn't available on window — good enough for a live price update;
    // the initial server-rendered price already uses the theme's real
    // money format.
    return (cents / 100).toLocaleString(document.documentElement.lang || 'pt-BR', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL',
    });
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}
